import React from "react";
import { NodeGroup } from "react-move";

import {
  OptionEnum,
  OptionModeEnum,
  OptionTypeEnum,
  TextOption,
} from "@/components/Option";
import { Option, Vote } from "@/service/Model";

import { TextGroup } from "./styles";

export type TextOptionsProps = {
  interactionId: string;
  isClickable: boolean;
  isSecret?: boolean;
  onVote: (vote: any, branch?: string) => void;
  options: Option[];
  resolveOption: (option: Option) => OptionEnum | undefined;
  resolveOptionMode: (option: Option) => OptionModeEnum;
  resolvePercent?: (option: Option) => number | undefined;
  slideId: string;
  type: OptionTypeEnum;
};

export const TextOptions: React.FC<TextOptionsProps> = (
  props: TextOptionsProps
): JSX.Element => {
  const startPixel = -30;
  const animationDelay = 250;
  const reactMoveNodes = props.options.map((option: Option, index: number) => {
    return {
      key: index,
      children: (
        <TextOption
          answer={props.resolveOption(option)}
          interactionId={props.interactionId}
          isClickable={props.isClickable}
          isSecret={props.isSecret}
          key={index}
          mode={props.resolveOptionMode(option)}
          onClick={(vote: Vote) => props.onVote(vote, option.branch)}
          optionId={option.id}
          percent={
            props.resolvePercent ? props.resolvePercent(option) : undefined
          }
          slideId={props.slideId}
          type={props.type}
        >
          {option.content}
        </TextOption>
      ),
    };
  });

  return (
    <NodeGroup
      data={reactMoveNodes}
      keyAccessor={(d: any) => d.key}
      start={() => ({ opacity: 0, move: startPixel })}
      update={() => ({ opacity: [1], move: [0] })}
    >
      {(nodes: any) => (
        <React.Fragment>
          {nodes.map((node: any, index: number) => (
            <TextGroup
              key={node.key}
              delay={animationDelay * (index + 1)}
              style={{
                transform: `translateY(${node.state.move}px)`,
                opacity: node.state.opacity,
              }}
            >
              {node.data.children}
            </TextGroup>
          ))}
        </React.Fragment>
      )}
    </NodeGroup>
  );
};
